import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';
import { getUrlParam, statistics } from '../services';

const api = services.api;

export const LoginLoader: Loader = {
    post: async function(params, config: ApiRequestConfig) {
        config.apiPath = '/login';
        const response: any = await api.post(params, config);
        response.name = response.username;

        // 埋点 登录
        statistics.load(response.staffno);
        statistics.trigger('113', '登录', '');

        return response;
    },
};

export const PrivilegesLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/menu/getAllMenusWithLevel';
        return await new Promise((resolve, _reject) => {
            api.get(params, config).then((response: any) => {
                let t = getUrlParam(window.location.href, 't');
                let u = getUrlParam(window.location.href, 'u');
                let c = getUrlParam(window.location.href, 'c');
                if (t && u && c) {
                    setTimeout(() => {
                        window.location.href = ENV.REDIRECT_URI;
                    });
                }
                resolve(response);
            });
        });
    },
};
